<div
    *ngIf="visible"
    class="ean-search-modal__backdrop"
    (click)="onCancel()"
    (keydown.escape)="onCancel()"
    tabindex="0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ean-search-modal-title"
>
    <div
        class="ean-search-modal"
        (click)="$event.stopPropagation()"
        (keydown.escape)="$event.stopPropagation()"
        tabindex="0"
    >
        <button
            type="button"
            class="ean-search-modal__close"
            (click)="onCancel()"
            aria-label="Close"
        >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path
                    d="M1 1l12 12M13 1L1 13"
                    stroke="currentColor"
                    stroke-width="1.6"
                    stroke-linecap="round"
                />
            </svg>
        </button>

        <h2 id="ean-search-modal-title" class="ean-search-modal__title">
            Search for products
        </h2>
        <p class="ean-search-modal__subtitle">
            Upload or paste manually EAN codes
        </p>

        <div class="ean-search-modal__tabs" role="tablist">
            <button
                type="button"
                role="tab"
                class="ean-search-modal__tab"
                [class.ean-search-modal__tab--active]="activeTab === 'paste'"
                [attr.aria-selected]="activeTab === 'paste'"
                (click)="selectTab('paste')"
            >
                Paste manually
            </button>
            <button
                type="button"
                role="tab"
                class="ean-search-modal__tab"
                [class.ean-search-modal__tab--active]="activeTab === 'upload'"
                [attr.aria-selected]="activeTab === 'upload'"
                (click)="selectTab('upload')"
            >
                Upload file
            </button>
        </div>

        <ng-container *ngIf="activeTab === 'paste'">
            <label class="ean-search-modal__label" for="ean-search-textarea">
                Paste EAN codes here:
            </label>
            <textarea
                id="ean-search-textarea"
                class="ean-search-modal__textarea"
                rows="6"
                [(ngModel)]="eanText"
                placeholder="Enter EAN codes separated by commas or new lines..."
            ></textarea>
            <p class="ean-search-modal__error" *ngIf="pasteError">{{ pasteError }}</p>
        </ng-container>

        <ng-container *ngIf="activeTab === 'upload'">
            <div
                class="ean-search-modal__dropzone"
                [class.ean-search-modal__dropzone--active]="isDragOver"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)"
                (click)="triggerFileInput()"
            >
                <button
                    type="button"
                    class="ean-search-modal__plus"
                    aria-label="Upload file"
                >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                        <path
                            d="M9 2.5v13M2.5 9h13"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                        />
                    </svg>
                </button>
                <p class="ean-search-modal__dropzone-title">
                    <span class="ean-search-modal__dropzone-link">Upload a file</span>
                    or drag and drop a file to upload
                </p>
                <p class="ean-search-modal__dropzone-hint">
                    Supported formats: .xls, .xlsx, .csv — one EAN per line or separated by commas
                </p>
                <p class="ean-search-modal__file-name" *ngIf="selectedFile">
                    {{ selectedFile.name }}
                </p>
            </div>
            <input
                #fileInput
                type="file"
                accept=".csv,.txt,.xls,.xlsx,text/csv,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                hidden
                (change)="onFileSelected($event)"
            />
            <p class="ean-search-modal__error" *ngIf="fileError">{{ fileError }}</p>
        </ng-container>

        <div class="ean-search-modal__footer">
            <button
                type="button"
                class="ean-search-modal__btn ean-search-modal__btn--secondary"
                (click)="onCancel()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="ean-search-modal__btn ean-search-modal__btn--primary"
                [disabled]="!canUpload"
                (click)="onUpload()"
            >
                {{ isUploading ? "Uploading..." : "Upload" }}
            </button>
        </div>
    </div>
</div>
